module.exports = function() {
  return new Worker(__webpack_public_path__ + "c93878e1d85df6e83d4f.worker.js");
};